const key = 'shui0000wang0000'
const headerBasic = 'zhongshuiwang:Eb105ruwBGH00136vcx80'
const commonName = 'auth-server/auth-api/v2'
const commonNameV2 = 'auth-server/auth-api/v2'
// const key = 'driver1234567890'
// const headerBasic = 'driver:driver'
// const commonName = 'monitor'

// const key = 'vgs1234567890vgs'
// const headerBasic = 'vgs:vgs'
// const commonName = 'match'

// const key = 'platformplatform'
// const headerBasic = 'platform:a050c7db77eb4b1bb8b2b'
// const commonName = '/stock'

// const driverName = '/driver'
// const matchName = '/match'
// const stockName = 'stock'
// const vehMonitor = '/monitor'
const payName = 'pay-server/pay'
const contractName = 'common-signature-server/common-signature'
const orderName = 'order-server/order'
const videoName = 'video-monitor-server/video'
const cutomerName = 'soc-customer-server/customer'
const stockName = 'order-server/order'
const signature = 'common-signature-server/common-signature'
const dataCenterName = 'data-center-server/dataCenter'
const vehMonitor = 'vgs-monitor-server/monitor'
const payServer = '/pay-server/pay'
const mapTime = {
  commonTime: 1000 * 5,
  waybillTime: 1000 * 5
}
const driverNameT = '/vgs-driver-server2/driver2'
const ZXpingzheng = 'http://202.108.57.67/cotb/m000A0100.html?'// 电子回单测试地址
// const ZXpingzheng = 'https://corp.bank.ecitic.com/cotb/m000A0101.html?'// 电子回单生产地址
const baseUrl = 'https://any.zw56.cn'
const crmServer3 = '/crm-server3/crm3'
export default {
  key,
  headerBasic,
  commonName,
  videoName,
  cutomerName,
  stockName,
  signature,
  dataCenterName,
  vehMonitor,
  mapTime,
  contractName,
  orderName,
  driverNameT,
  payName,
  payServer,
  ZXpingzheng,
  baseUrl,
  crmServer3,
  commonNameV2
}
